






































































































































import Vue from 'vue';
import BLOGS_DATA from '@/configs/blogs';

export default Vue.extend({
  data() {
    return {
      drawer: true,
      dialog: false,
      items: [
        { icon: 'mdi-contacts', text: 'Home', to: '/' },
        {
          icon: 'mdi-history',
          text: 'What Will I Eat',
          to: '/what-will-i-eat/index'
        },
        {
          icon: 'mdi-content-copy',
          text: 'Generate SVG',
          to: '/generate-svg/index'
        },
        ...BLOGS_DATA
        // {
        //   icon: 'mdi-chevron-up',
        //   'icon-alt': 'mdi-chevron-down',
        //   text: '',
        //   model: false,
        //   children: [{ icon: 'mdi-@', text: 'Create label' }]
        // }
      ]
    };
  }
});
